import { usePageTranslation } from '@/shared/hooks';
import { DarkMode as DarkModeIcon, LightMode as LightModeIcon } from '@/shared/ui/icons';
import { useTheme } from '../../contexts/ThemeContext';

export function ThemeToggle() {
    const { t } = usePageTranslation({ filePath: 'shared/components/Layout' });
    const { isDark, toggleTheme } = useTheme();

    return (
        <label
            className="swap swap-rotate btn btn-ghost btn-circle has-[input:focus-visible]:outline-2 has-[input:focus-visible]:outline-offset-2 has-[input:focus-visible]:outline-base-content"
            title={isDark ? t('themeLight') : t('themeDark')}
            aria-label={t('themeToggle')}
        >
            <input
                type="checkbox"
                checked={isDark}
                onChange={toggleTheme}
                aria-label={t('themeToggle')}
            />
            <LightModeIcon className="swap-off h-5 w-5" />
            <DarkModeIcon className="swap-on h-5 w-5" />
        </label>
    );
}
